module.exports = __webpack_public_path__ + "static/media/shake.cc509223.jpg";